'use client';

import { useAtom } from 'jotai';
import { flashMessageAtom } from 'src/services/state/atoms/flash';

import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';
import { Alert } from '@trussworks/react-uswds';

const FlashMessage = () => {
  const pathname = usePathname();
  const [flashMessage, setFlashMessage] = useAtom(flashMessageAtom);

  // Clear the message on URL change (i.e. page nav)
  useEffect(() => {
    setFlashMessage((prev) => {
      if (prev && prev.redirectCount === undefined) {
        // Undefined redirectCount gets set to 0
        return { ...prev, redirectCount: 0 };
      } else if (prev?.redirectCount && prev.redirectCount > 0) {
        // If redirectCount is defined, decrement it
        return { ...prev, redirectCount: prev.redirectCount - 1 };
      } else {
        // If redirectCount is 0 or less, clear the message
        return null;
      }
    });
  }, [pathname, setFlashMessage]);

  return (
    <>
      {flashMessage && (
        <Alert
          role="alert"
          type={flashMessage.type}
          heading={flashMessage.heading}
          headingLevel="h2"
          className="margin-top-2"
          validation
          data-testid="flash-message"
        >
          <span>{flashMessage.message}</span>
        </Alert>
      )}
    </>
  );
};

export default FlashMessage;
